import React, { useState, useMemo } from 'react';

const LegendaAutomatica = ({ 
  groupRefs, 
  imageStates, 
  handleToggleLightGroup, 
  visibleGroups = [], 
  sendCommand = null, 
  className = "campo-clickable-element-pagina1"
}) => {
  const [expanded, setExpanded] = useState(false);
  
  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  // Otimização: Use useMemo para calcular esses valores apenas quando necessário
  const { validLightGroups, legendaItems } = useMemo(() => {
    // Conta quantos LightGroups válidos temos para calcular a altura
    const validRefs = Object.entries(groupRefs.current || {})
      .filter(([_, ref]) => ref && ref.current);
    
    const validCount = validRefs.length;
    
    // Extrai os dados dos componentes LightGroup para criar a legenda
    const items = validRefs.map(([groupId, ref], index, array) => {
      const props = ref.current.props;
      
      // Encontra o grupo correspondente na lista de grupos visíveis
      const group = visibleGroups.find(g => g.id === groupId) || {};
      
      // Usa o número do circuito do grupo se disponível, ou extrai do groupId
      const number = group.circleNumber || parseInt(groupId.replace(/\D/g, ''));
      
      const description = props.descricao;
      const imageState = imageStates[groupId];
      const isLast = index === array.length - 1;

      // Verifica se temos mais de 12 acionamentos
      const hasMultipleItems = validCount > 12;
      
      // Estilo para altura dinâmica quando expandido
      // Se tivermos mais de 12 itens, a altura não é fixa para permitir overflow
      const itemStyle = expanded ? 
        (hasMultipleItems ? 
          { minHeight: '40px' } : // altura mínima quando tem muitos itens
          { height: `${100 / (validCount + 1)}%` } // altura proporcional quando tem poucos itens
        ) : {};

      return (
        <div
          key={groupId}
          id={`clickable-element-${groupId}`}
          className={isLast ? "clickable-element-last" : "clickable-element"}
          style={itemStyle}
          onClick={() => {
            handleToggleLightGroup(groupId, !imageState);
            
            // Usa sendCommand se fornecido, ou ref.current.sendCommand como fallback
            if (sendCommand && group) {
              const command = imageState ? 
                { modulo: group.modulo, idx: group.idx, status: "OFF" } : 
                { modulo: group.modulo, idx: group.idx, status: "ON" };
              sendCommand(description, command);
            } else if (ref.current) {
              ref.current.sendCommand(
                description,
                imageState ? ref.current.props.offCommand : ref.current.props.onCommand
              );
            }
          }}
        >
          <p className={`NumberTextBar${imageState ? 'Highlighted' : ''}`}>{number}</p>
          <p className="textBar">{description}</p>
        </div>
      );
    });
    
    return { validLightGroups: validCount, legendaItems: items };
  }, [groupRefs, imageStates, expanded, handleToggleLightGroup, visibleGroups, sendCommand]);

  // Verifica se temos mais de 12 itens para aplicar overflow
  const hasMultipleItems = validLightGroups > 12;
  
  // Estilo dinâmico do cabeçalho
  const headerStyle = expanded ? 
    (hasMultipleItems ? 
      { minHeight: '40px' } : // Altura mínima quando tem muitos itens
      { height: `${100 / (validLightGroups + 1)}%` } // Altura proporcional quando tem poucos itens
    ) : {};

  // Estilo do contêiner de legenda com overflow quando necessário
  const legendaContainerStyle = hasMultipleItems ? {
    maxHeight: 'calc(100% - 7%)', // Reserva espaço para o cabeçalho
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column'
  } : {};

  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        zIndex: expanded ? 15 : 10,
        pointerEvents: expanded ? 'auto' : 'none' // Impede que a legenda bloqueie os cliques quando minimizada
      }}
    >
      <div
        className={`Topico-Menubar${expanded ? '-expanded' : ''}`}
        style={expanded ? { height: '100%', pointerEvents: 'auto' } : { pointerEvents: 'auto' }}
      >
        <p
          className={`topicoParagrafoMenuBar${expanded ? '-expanded' : ''}`}
          style={{...headerStyle, cursor: 'pointer', userSelect: 'none'}}
          onClick={toggleExpand}
        >
          <b>Acionamentos</b>
        </p>

        {expanded && (
          <div className="legenda" style={legendaContainerStyle}>
            {legendaItems}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(LegendaAutomatica);